import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-upload-document-modal',
  templateUrl: './upload-document-modal.component.html',
  styleUrls: ['./upload-document-modal.component.scss']
})
export class UploadDocumentModalComponent implements OnInit {
  @Output() emitData = new EventEmitter<any>();
  @Input() uploading: boolean;
  @Input() fileUrl: string;
  @Input() docExists: boolean;
  @Input() error: boolean;

  constructor() { }

  ngOnInit() {
    this.emitData.emit({ cancel: false, override: false });
    this.uploading = true;
  }
  replaceDoc() {
    this.emitData.emit({ cancel: false, override: true });
    this.uploading = false;
    this.docExists = false;
  }

  cancelUpload() {
    this.emitData.emit({ cancel: true, override: false });
    this.uploading = false;
    this.docExists = false;
  }
}
@NgModule({
  declarations: [UploadDocumentModalComponent],
  entryComponents: [
    UploadDocumentModalComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    ActionLinkModule,
    MatProgressBarModule,
    LinkModule,
  ]
})
export class UploadDocumentModalModule { }
